import { Button, FormInput } from '@basqet-dashboard/common/components/';
import { APP_NAME } from '@basqet-dashboard/common/config';
import { useCurrencies, useSessionStorage } from '@basqet-dashboard/common/hooks';
import { BackButton } from '@pages/payout/back-button';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { SelectedWallet } from '../../selected-wallet';
import { TransactionDetails } from '../../transaction-details';

const ConfirmPayout = ({ transactionInfo, setCurrentStage }) => {
  const [token] = useSessionStorage(APP_NAME, '');
  const { TwoFaEnabled } = token;

  const { cryptoCurrencies } = useCurrencies();
  const currency = cryptoCurrencies.find(
    (currency) => +currency.value === +transactionInfo.currency_id
  );

  const [confirmTransaction, setConfirmTransaction] = useState(false);

  const toggleConfirmTransaction = () => {
    setConfirmTransaction((confirmTransaction) => !confirmTransaction);
  };

  const onSubmit = () => {
    if (TwoFaEnabled) setCurrentStage('TWOFA_AUTHENTICATION');
    else setCurrentStage('PROCESS_PAYOUT');
  };

  return (
    <div className="card confirm__payout">
      <BackButton onClick={() => setCurrentStage('ADD_BENEFICIARIES')} />
      <div className="card__header">
        <h3 className="card__title">Confirm Transaction</h3>
      </div>
      <SelectedWallet currencyId={transactionInfo?.currency_id} />
      <TransactionDetails transaction={transactionInfo} currencyName={currency?.slug} />
      <div className="card__footer">
        <FormInput
          type="checkbox"
          name="confirm_transaction"
          label="Please confirm the transaction and proceeed"
          id="confirm_transaction"
          checked={Boolean(confirmTransaction)}
          register={{ onChange: toggleConfirmTransaction }}
        />
        <Button disabled={!confirmTransaction} isFull onClick={onSubmit}>
          Payout
        </Button>
      </div>
    </div>
  );
};
ConfirmPayout.propTypes = {
  transactionInfo: PropTypes.object,
  setCurrentStage: PropTypes.func
};

export { ConfirmPayout };
